import React from "react";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useIsGitTriggersEnabled() {
    return useOctopusFeatureToggle("git-triggers", false);
}
export function GitTriggersFeatureToggleVisibility({ children }: React.PropsWithChildren<unknown>) {
    const isGitTriggersEnabled = useIsGitTriggersEnabled();
    return isGitTriggersEnabled ? <>{children}</> : null;
}
